export function formatPrice(cents: number, currency: string): string {
  if (!cents) return "—";
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency }).format(cents / 100);
}

export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("nl-NL", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export function toLocalDatetime(iso: string | null): string {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch {
    return "";
  }
}

export function fromEUR(cents: number): string {
  if (!cents) return "";
  return (cents / 100).toFixed(2);
}

